export const copyToClipboard = (value?: string | null) => {
    if (!value) {
        return false
    }
    const element = document.createElement("textarea")
    element.value = value
    element.setAttribute("readonly", "")
    element.style.position = "absolute"
    element.style.left = "-9999px"
    document.body.appendChild(element)
    element.select()
    const success = document.execCommand("copy")
    document.body.removeChild(element)
    return success
}
